export const NOT_STARTED = 'NOT_STARTED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const WAITING = 'WAITING';
export const COMPLETED = 'COMPLETED';
export const DEFERRED = 'DEFERRED';